/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Col, Modal, Row, Button, message, Spin, Tabs, Input, Form } from "antd";
import { FolderFilled, FolderOpenOutlined, FileZipOutlined, CaretRightOutlined, CaretDownOutlined, ExclamationCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { IoIosCreate } from "react-icons/io";
import { MdOutlineUploadFile } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { transactionLaneDataHandle } from "../state/actions";
import { useLocation } from "react-router-dom";
import styles from "../style/document.module.css";
import _, { get } from "lodash";
import axios from "axios";
import { checkIfDisabled, createOfferContractTypes, customerDocsContTractTypes, disabledTransactionText, listingContractTypes } from "../../Common/commondata/commonData";
import { filteredTransactionData, removePersonObject } from "../../PropertyComp/components/helper";
import UploadPdfDoc from "../../PropertyComp/components/UploadPdfDoc";
import { formatPhoneNumber, getCityFromFullAddress, getCoAgentsIds, getStreetAddress } from "../../Common/utils/extraFunctions";
import { getFullNamesFromArray } from "../../DocumentSection/utils/helper";
import { getBuildDataForCustomerdocs, prepareCurrentAgentDetails } from "../../PropertyComp/utils/helper";
import { PropertyDocsModal } from "../../PropertyComp/components/PropertyDocsModal";
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';


const StyledTree = styled.div`
  line-height: 1.9;
`;
const StyledFile = styled.div`
  padding-left: px;
  display: flex;
  align-items: center;
  span {
    margin-left: 0px;
  }
`;
const StyledFolder = styled.div`
  padding-left: 0px;
  .folder--label {
    display: flex;
    align-items: center;
    span {
      margin-left: 0px;
    }
`;
const Collapsible = styled.div`
  height: ${(p) => (p.isOpen ? "0" : "auto")};
  overflow: hidden;
`;

const File = ({ doraDocItem, selectedData, seller, getTransactionLaneData, insideFolder, section }) => {
    let delegate = (section === "DELEGATE");
    const bos = (section === "BOS");
    const { getDoraDocumentsData } = useSelector((state) => state.rtdTransactionLane);
    let dispatch = useDispatch();

    const currentAgentDetails = selectedData?.currentAgentId;

    const [modalVisible, setModalVisible] = useState({
        isModalVisible: false,
        isEmailModalVisible: false,
        isEmailPresent: false,
        isAllEmailsModalOpen: false,
    });
    const [allData, setAllData] = useState({
        uploadPdfDoc: false,
        file: "",
        ...(delegate
            ? {
                delegateSide: seller === "SELLER" ? "SELLER" : "BUYER",
                delegateOwnerId: currentAgentDetails?._id,
            }
            : (bos && { delegateOwnerId: currentAgentDetails?._id, screenType: "BOS" })),
    });


    const location = useLocation();

    const handleCancel = () => {
        setModalVisible({ ...modalVisible, isModalVisible: false })
    };

    const { getTitleCompanySelectedData } = useSelector((state) => state.rtdTransactionLane);
    const urlShortHand = (ele) => {
      try {
        selectedData = filteredTransactionData({ ele, selectedData });

        const officeDetails = {
          officeLogo: currentAgentDetails?.brokerageData?.logo || "",
          name: currentAgentDetails?.brokerageData?.name?.trim() || "",
          address: currentAgentDetails?.brokerageData?.address || "",
          agentId: currentAgentDetails?._id,
        };
        if (customerDocsContTractTypes.includes(ele?.contractType)) {
          const buildData = getBuildDataForCustomerdocs({ contractType: ele?.contractType, contractId: ele.contractId, currentAgentDetails, transactionData: selectedData?.newTransactionData, selectedData, delegate, bos, item: { isProperty: seller === "SELLER" }, officeDetails });
          return dispatch(transactionLaneDataHandle.generateUrlIdAndRedirect({ buildData, currentPath: location?.pathname }));
        }
        const transactionData = selectedData?.newTransactionData || selectedData?.transactionData || {};
        let commonBuildData = {
          builtForId: currentAgentDetails?._id,
          key: currentAgentDetails?._id,
          builtForSection: "DOCUMENT",
          signable: true,
          openFor: seller === "SELLER" ? "SELLER_AGENT" : "BUYER_AGENT",
          contractId: ele.contractId,
          contractType: ele.contractType,
          offerId: selectedData?.offerId,
          propertyId: selectedData?.propertyId,
          token: localStorage.getItem("userAuth"),
          RTDInitiator: seller === "SELLER" ? "SELLER" : "BUYER",
          ...((delegate || bos) ? { delegateOwnerId: currentAgentDetails?._id } : {}),
          ...(bos && { screenType: "BOS" }),
        };

        const buildData = {
          ...commonBuildData,
          buyerAgentIds: getCoAgentsIds(selectedData?.buyerAgentIds),
          sellerAgentIds: getCoAgentsIds(selectedData?.sellerAgentIds),
          urlData: {
            ...(transactionData ? { ...transactionData } : {}),
            ...(ele?.prefillValues || {}),
            Buyers: removePersonObject(selectedData?.buyerIds),
            Sellers: removePersonObject(selectedData?.sellerIds),
            ...(["CB_NOCOLS"].includes(ele?.contractType)
              ? {
                  ...(selectedData?.ertsData?.CompensationSaleCommissionPercentage ? { CompensationSaleCommissionPercentage: selectedData?.ertsData?.CompensationSaleCommissionPercentage } : {}),
                  TitleCompanyName: getTitleCompanySelectedData?.titleCompanyName || "",
                  TitleCloserName: getTitleCompanySelectedData?.titleCloserName || "",
                  TitleCloserEmail: getTitleCompanySelectedData?.titleCloserEmail || "",
                  TitleCloserPhone: formatPhoneNumber(getTitleCompanySelectedData?.titleCloserPhone) || "",
                  SalesRepName: getTitleCompanySelectedData?.salesRepName || "",
                  SalesRepEmail: getTitleCompanySelectedData?.salesRepEmail || "",
                  SalesRepPhone: formatPhoneNumber(getTitleCompanySelectedData?.salesRepPhone) || "",
                }
              : {}),
            ...((ele?.contractType === "CI" || ele?.contractType === "TO") && getTitleCompanySelectedData
              ? {
                  TitleCompanyLogo: getTitleCompanySelectedData.titleCompanyLogo || "",
                  TitleCompanyName: getTitleCompanySelectedData.titleCompanyName || "",
                  TitleOfficeName: getTitleCompanySelectedData.titleOfficeName || "",
                  TitleOfficeEmail: getTitleCompanySelectedData.titleOfficeEmail || "",
                  TitleOfficeAddress: getTitleCompanySelectedData.titleOfficeAddress || "",
                  TitleOfficePhoneNo: getTitleCompanySelectedData.titleOfficePhoneNo || "",
                  TitleOfficeFaxNo: getTitleCompanySelectedData.titleOfficeFaxNo || "",
                  TitleCloserName: getTitleCompanySelectedData.titleCloserName || "",
                  TitleCloserEmail: getTitleCompanySelectedData.titleCloserEmail || "",
                  SalesRepName: getTitleCompanySelectedData.salesRepName || "",
                  SalesRepEmail: getTitleCompanySelectedData.salesRepEmail || "",
                }
              : {}),
            ...(["SA", "CB_NOCOLS"].includes(ele?.contractType)
              ? {
                  BrokerName: currentAgentDetails?.fullName || "",
                  BrokerEmailAddress: currentAgentDetails?.email || "",
                  BrokerFirmName: currentAgentDetails?.brokerageData?.name || "",
                  BrokerFirmAddress: currentAgentDetails?.brokerageData?.address || "",
                  BrokerPhoneNumber: formatPhoneNumber(currentAgentDetails?.mobilePhoneNumber?.phoneNumber),
                  BrokerFaxNumber: formatPhoneNumber(currentAgentDetails?.brokerageData?.faxNumber),
                }
              : {}),
            ...(["CRE_RE", "CRE_LA"].includes(ele?.contractType)
              ? {
                  StreetAddress: getStreetAddress(selectedData?.address),
                  City: getCityFromFullAddress(selectedData?.address),
                  ...(ele?.contractType === "CRE_RE" && { BuyerBrokersList: getFullNamesFromArray(selectedData?.buyerAgentIds) }),
                  ...(ele?.contractType === "CRE_LA" && { SellerBrokersList: getFullNamesFromArray(selectedData?.sellerAgentIds) }),
                }
              : {}),
            officeDetails,
          },

          ...((ele?.contractType === "CI" || ele?.contractType === "TO") && getTitleCompanySelectedData
            ? {
                titleCompanyDetails: {
                  inBuilt: getTitleCompanySelectedData.inBuilt,
                  selectedBy: getTitleCompanySelectedData.selectedBy,
                  ...(getTitleCompanySelectedData.titleOfficeId ? { titleOfficeId: getTitleCompanySelectedData.titleOfficeId } : {}),
                  ...(getTitleCompanySelectedData.salesRepId ? { salesRepId: getTitleCompanySelectedData.salesRepId } : {}),
                  ...(getTitleCompanySelectedData.titleCloserId ? { titleCloserId: getTitleCompanySelectedData.titleCloserId } : {}),
                },
              }
            : {}),
        };
        if (["CB_SAEFPT", "DC_TAC"].includes(ele.contractType)) {
          buildData.urlData.Buyers = [];
          buildData.urlData.Sellers = [];
        }
        if (["DC_ADBA", "DC_BCLA", "DC_CLASLC"].includes(ele?.contractType)) {
          const { agentArray } = prepareCurrentAgentDetails({ currentAgentDetails, contractType: ele?.contractType });
          delete buildData.buyerAgentIds;
          delete buildData.sellerAgentIds;
          if (ele.contractType === "DC_ADBA") {
            buildData.urlData.BuyerAgents = seller === "BUYER" ? agentArray : [];
            buildData.urlData.SellerAgents = seller === "SELLER" ? agentArray : [];
          } else {
            buildData.urlData.BuyerAgents = seller === "BUYER" && ele.contractType === "DC_BCLA" ? agentArray : transactionData.BuyerAgents?.slice(0, 2) ?? [];
            buildData.urlData.SellerAgents = seller === "SELLER" && ele.contractType === "DC_CLASLC" ? agentArray : transactionData.SellerAgents?.slice(0, 2) ?? [];
          }
        }
        return dispatch(transactionLaneDataHandle.generateUrlIdAndRedirect({ buildData, currentPath: location?.pathname, delegateOwnerId: delegate && currentAgentDetails?._id }));
      } catch (error) {}
    };

    let docInRtd = false;
    getTransactionLaneData?.forEach((el) => {
        if (el.contractType === doraDocItem.contractType) {
            docInRtd = true;
        }
    });

    const handleCreateNew = () => {
        if((doraDocItem?.contractType === "CO" && !getTransactionLaneData?.[0]?.showSeller) || (doraDocItem?.contractType === "MH_CO" && !getTransactionLaneData?.[0]?.showSeller && getTransactionLaneData?.[0]?.contractType === "CBS_MH")){
            message.info("This document can only be created once the offer has been sent to the opposite side.")
            return;
        }

        if (((doraDocItem?.contractType === "TO") || (doraDocItem?.contractType === "CI")) && (!getTitleCompanySelectedData?.selectedBy)) {
            message.error("Please select/add a Title Company to proceed with the following document!");
            return;
        }
        if ((doraDocItem?.contractType === "INSP_RESOL") && (getTransactionLaneData?.filter((el) => el?.contractType === "INSP_OBJ")?.length <= 0)) {
            Modal.confirm({
                title: "Warning! An inspection objection document should exist before creating an inspection resolution document! Are you sure you want to proceed?",
                okText: "Yes",
                cancelText: "No",
                icon: <ExclamationCircleOutlined />,
                onOk: () => {
                    urlShortHand(doraDocItem)
                },
                onCancel: () => {
                    handleCancel()
                }
            })
        } else {
            urlShortHand(doraDocItem)
        }

    }


    useEffect(() => {
        if (seller === "BUYER") {
            let data = selectedData?.newTransactionData?.Buyers?.filter((el) => el.personId === null);
            if (data?.length > 0) {
                setModalVisible({ ...modalVisible, isEmailPresent: false })
            } else {
                setModalVisible({ ...modalVisible, isEmailPresent: true })
            }
        } else {
            let data = selectedData?.newTransactionData?.Sellers?.filter((el) => el.personId === null);
            if (data?.length > 0) {
                setModalVisible({ ...modalVisible, isEmailPresent: false })
            } else {
                setModalVisible({ ...modalVisible, isEmailPresent: true })
            }
        }
    }, [selectedData]);
    const showConfirmATAEModal = ({ message }) => {
        Modal.confirm({
            title: message,
            content: "",
            okText: "Yes",
            cancelText: "No",
            icon: <ExclamationCircleOutlined />,
            onOk() {
                setModalVisible({ ...modalVisible, isModalVisible: true })
            },
            onCancel() { },
        });
    }

    const hasActiveCBSR = getTransactionLaneData?.some(el => createOfferContractTypes.includes(el.contractType));
    const handleDocNameClick = ({ doraDocItem }) => {
        // let documentName = "";
        let contractType = "";
        getDoraDocumentsData?.forEach(doc => {
            if (createOfferContractTypes.includes(doc.contractType)) {
                //   documentName = doc.name;
                contractType = doc.contractType;
            }
        });
        if (!hasActiveCBSR) {
            message.error(`To add another document, you must have an active ${contractType} in the Transaction Dashboard.`)
        }

        if (["MH_ATAE"].includes(doraDocItem.contractType)) {
            let foundMHOffer = getTransactionLaneData?.some(el => el.contractType === "CBS_MH");
            if (!foundMHOffer) {
                let message = `This transaction document is for Manufactured Home. Are you sure you don't want to use an Amend Extend document instead?`
                showConfirmATAEModal({ message });
                return;
            }
        } else if (["ATAE"].includes(doraDocItem.contractType)) {
            let foundMHOffer = getTransactionLaneData?.some(el => el.contractType === "CBS_MH");
            if (foundMHOffer) {
                let message = `This transaction document is not for Manufactured Home. Are you sure you don't want to use a Manufactured Home Amend/Extend document instead?`
                showConfirmATAEModal({ message })
                return
            }
        }
        setModalVisible({ ...modalVisible, isModalVisible: true })
    }

    const checkForDisable = checkIfDisabled({ openFor: seller, actualPropertyStatus: selectedData?.actualPropertyStatus, buyingStatus: selectedData?.buyingStatus, offerStatus: selectedData?.status, enableArray: doraDocItem?.enableDuringDisableStatus });

    const handleUploadNew = () => {
        setAllData({
            ...allData,
            uploadPdfDoc: true,
        })
    }

    const handleModalCancel = () => {
        setAllData({
            ...allData,
            uploadPdfDoc: false
        })
    }

    return (
        <StyledFile 
            style={{
                pointerEvents: listingContractTypes.includes(doraDocItem?.contractType) ? "none" : "auto",
                opacity:  listingContractTypes.includes(doraDocItem?.contractType) ? 0.6 : 1,
            }}
        >
            <span
                style={{
                    fontSize: "18px",
                    fontWeight: 500,
                    color: docInRtd && "rgb(110 153 214)" || "rgb(176, 176, 176)",
                    width: "100%",
                    marginTop: "4px",
                    marginLeft: insideFolder ? "21px" : "auto",
                    paddingLeft: 0,
                    pointerEvents: createOfferContractTypes.includes(doraDocItem?.contractType) ? "none" : "pointer",
                    cursor: createOfferContractTypes.includes(doraDocItem?.contractType) ? "default" : "pointer",
                }}
            >
                <FileZipOutlined style={{ fontSize: "20px" }} />
                <span
                    className={styles.documentsName}
                    {...(checkForDisable?.disabled ? { onClick: disabledTransactionText } : { onClick: () => handleDocNameClick({ doraDocItem }) })}
                >
                    {doraDocItem?.name}
                </span>
            </span>
            <UploadPdfDoc selectedData={{ ...selectedData, ...doraDocItem, RTDInitiator: seller }} allData={allData} setAllData={setAllData} handleModalCancel={handleModalCancel} open={allData?.uploadPdfDoc}  getCoordinateItem={{ isProperty: seller === "SELLER" }}  />
            <Modal visible={hasActiveCBSR && modalVisible.isModalVisible} onCancel={handleCancel} footer={[]}>
                {selectedData?.propertyYearBuilt > 1977 && (doraDocItem.contractType === "LBPOS" || doraDocItem.contractType === "LBPD") && (
                    <p style={{ fontWeight: "500", color: "#2976be" }}>
                        Note : <text style={{ fontWeight: "500", color: "darkgray" }}>Document Not Required ! This property was built after 1977, exempting the need for this document.</text>{" "}
                    </p>
                )}
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        gap: "5px",
                        width: "51%",
                        margin: "auto",
                        paddingLeft: "30px",
                    }}
                >
                    <p
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: "20px",
                            color: "#2976be",
                            cursor: "pointer",
                        }}
                        onClick={handleCreateNew}
                    >
                        <IoIosCreate size={25} /> Create New
                    </p>
                    <p
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: "20px",
                            color: ["CO", "MH_CO"].includes(doraDocItem?.contractType) ? "#ccc" : "#2976be",
                            cursor: ["CO", "MH_CO"].includes(doraDocItem?.contractType) ? "not-allowed" : "pointer",
                            pointerEvents: ["CO", "MH_CO"].includes(doraDocItem?.contractType) ? "none" : "auto",
                        }}
                        onClick={["CO", "MH_CO"].includes(doraDocItem?.contractType) ? null : handleUploadNew}
                    >
                        <MdOutlineUploadFile size={25} /> Upload PDF
                    </p>
                </div>
            </Modal>
        </StyledFile>
    );
};

// its an folder structure component
const Folder = ({ name, children, selectedData, fiters }) => {
    const [isOpen, setIsOpen] = useState(fiters?.search ? true : false);
    const handleToggle = (e) => {
        e.preventDefault();
        setIsOpen(!isOpen);
    };

    const archivedOrTerminated = selectedData?.status === "TERMINATED"
    return (
        <StyledFolder>
            <div
                className="folder--label"
                onClick={handleToggle}
                style={{
                    cursor: "pointer",
                    pointerEvents: archivedOrTerminated ? "none" : "pointer",
                    alignItems: 'baseline',
                }}
            >
                {isOpen ? (
                    <>
                        <CaretDownOutlined
                            style={{
                                fontSize: "1.3rem",
                                marginRight: "5px",
                                color: archivedOrTerminated ? "#b0b0b0" : "rgb(107,152,199)",
                            }}
                        />{" "}
                        <FolderOpenOutlined
                            style={{ fontSize: "20px", color: "rgb(107,152,199)" }}
                        />
                    </>
                ) : (
                    <>
                        <CaretRightOutlined style={{ fontSize: "1.3rem", color: "#8C8C8C" }} />
                        <FolderFilled
                            style={{
                                fontSize: "20px",
                                color: archivedOrTerminated ? "#b0b0b0" : "rgb(107,152,199)",
                                // marginLeft: "14px",
                            }}
                        />
                    </>
                )}
                <span
                    style={{
                        fontSize: "19px",
                        fontWeight: 600,
                        color: "#8C8C8C",
                        marginTop: "4px",
                        paddingLeft: "4px",
                    }}
                >
                    {name}
                </span>
            </div>
            <Collapsible isOpen={!isOpen}>{children}</Collapsible>
        </StyledFolder>
    );
};

const Tree = ({ children }) => {
    return <StyledTree>{children}</StyledTree>;
};

Tree.File = File;
Tree.Folder = Folder;

export default function DoraDocument({ seller, showDrawer, section }) {
  const { getTransactionLaneData, getIndividualTransactionData, getDoraDocumentsData, getDoraDocumentsLoading, getDoraDocumentsError } = useSelector((state) => state.rtdTransactionLane);
  const { getUserDetailsData } = useSelector((state) => state.account);
  const screens = useBreakpoint();
  //   const [activeKey, setActiveKey] = useState("1");
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState({
    propertyDocs: false,
  });
  const [nestedModalOpen, setNestedModalOpen] = useState({
    isUploadDocsModal: false,
    isEmailModalVisible: false,
    isLegendOpen: false,
    sendMultipleDoc: false,
    isclearTransactionLaneData: false,
    resureSignDoc: false,
    isEditNameModalOpen: false,
    editDocDetails: {},
  });

  const [tabSelect, setTabSelect] = useState("1");
  const [fiters, setFilters] = useState({ search: "" });
  const [form] = Form.useForm();

  const [doraFormsData, setDoraFormsData] = useState([]);

  useEffect(() => {
    if (Array.isArray(getTransactionLaneData) && Array.isArray(getDoraDocumentsData)) {
      const foundMH = getTransactionLaneData.some((el) => el.contractType === "CBS_MH");
      const newData = getDoraDocumentsData.filter((el) => (foundMH ? el.contractType !== "CO" : el.contractType !== "MH_CO"));
      setDoraFormsData(newData);
    }
  }, [getTransactionLaneData, getDoraDocumentsData, fiters]);

  let unmounted = {
    value: false,
  };
  let source = axios.CancelToken.source();
  useEffect(() => {
    if (showDrawer) {
      let data = {
        listType: seller,
        offerId: getIndividualTransactionData.offerId,
      };
      dispatch(transactionLaneDataHandle.getDoraDocumentsData({ data, fiters, source, unmounted, brokerageId: getUserDetailsData?.brokerageData?.brokerageId?._id }));

      return () => {
        unmounted.value = true;
        source.cancel("Cancelling in cleanup");
      };
    }
  }, [showDrawer, fiters]);

  useEffect(() => {
    const modalOpenObj = JSON.parse(localStorage.getItem("modalOpen")) || {};
    if (modalOpenObj?.openModal && modalOpenObj.openingFrom === "RTD_PROPERTY_DOCS" && modalOpenObj?.offerId === getIndividualTransactionData?.offerId) {
      setIsModalOpen({ ...isModalOpen, propertyDocs: true });
      localStorage.removeItem("modalOpen");
    }
  }, [getIndividualTransactionData]);

  function totratlast() {
    let arr = _.cloneDeep(doraFormsData);
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].contractType === "TO") {
        arr.push(...arr.splice(i, 1));
      }
      if (arr[i].contractType === "TR") {
        arr.push(...arr.splice(i, 1));
      }
    }
    return arr;
  }

  //   const handleChange = (value) => {
  //     setActiveKey(value);
  //   };

  const handleClear = () => {
    form.resetFields();
    setFilters({
      search: "",
    });
  };

  //debounce logic to call search api
  const debouncedFunction = _.debounce((value) => {
    setFilters({
      search: value,
    });
  }, 1000);

  const handleSearch = (event) => {
    const value = event.target.value;
    debouncedFunction(value);
  };

  return (
    <div className={styles.formsAndAffiliatesOuterCont}>
      {isModalOpen?.propertyDocs && <PropertyDocsModal isModalOpen={isModalOpen} section={section} setIsModalOpen={setIsModalOpen} role={seller} item={{ ...(getIndividualTransactionData && getIndividualTransactionData), isProperty: seller === "SELLER", isOffer: seller === "BUYER" }} isWeb={true} reloadSection={"RTD"} tabSelect={tabSelect} setTabSelect={setTabSelect} setNestedModalOpen={setNestedModalOpen} nestedModalOpen={nestedModalOpen} />}
      <Tabs
        // onChange={handleChange}
        type="card"
        defaultActiveKey="1"
        tabBarExtraContent={
          <div style={{ paddingRight: screens.xxl ? "100px" : screens.xl ? "100px" : screens.lg ? "80px" : screens.md ? "60px" : screens.sm ? "20px" : "20px" }}>
            <Button
              type="primary"
              onClick={() => setIsModalOpen((prev) => ({ ...prev, propertyDocs: true }))}
              style={{
                fontWeight: "bold",
              }}
            >
              Property Docs
            </Button>
          </div>
        }
      >
        <Tabs.TabPane tab={<span className={styles.TabPaneTitle}>Forms</span>} key="1" animated>
          <div className={styles.documentCont}>
            {
              <Row>
                <Row style={{ width: "100%", flexWrap: "nowrap", justifyContent: "center", gap: 5 }}>
                  <Col className={styles.searchInputBoxCol}>
                    <div className={styles.searchInputBox}>
                      <Form form={form} initialValues={{}}>
                        <Form.Item name="search">
                          <Input allowClear placeholder="Search here..." suffix={<SearchOutlined />} onChange={handleSearch} size="middle" />
                        </Form.Item>
                      </Form>
                    </div>
                  </Col>
                  <Col>
                    <div className={styles.sortBox}>
                      <Button
                        style={{
                          background: "#3a74b6",
                          color: "whitesmoke",
                          fontWeight: "bold",
                          border: "none",
                          padding: "0 10px",
                        }}
                        onClick={handleClear}
                      >
                        <div>Reset</div>
                      </Button>
                    </div>
                  </Col>
                </Row>
                {getDoraDocumentsLoading ? (
                  <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spin size="large" />
                  </div>
                ) : getDoraDocumentsError ? (
                  ""
                ) : (
                  <Row className={styles.documentScroll}>
                    <Col
                      span={24}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        overflowY: "auto",
                        paddingLeft: "10px",
                      }}
                    >
                      <Tree>
                        {totratlast()?.length
                          ? totratlast().map((item) => {
                              if (item.doc_second.length > 0) {
                                return (
                                  <Tree.Folder key={item._id} name={item.name} style={{ cursor: "pointer" }} getTransactionLaneData={getTransactionLaneData} fiters={fiters}>
                                    {item.doc_second.map((element) => {
                                      return <Tree.File key={element._id} doraDocItem={element} selectedData={getIndividualTransactionData} seller={seller} getTransactionLaneData={getTransactionLaneData} insideFolder={true} section={section} />;
                                    })}
                                  </Tree.Folder>
                                );
                              } else {
                                return <Tree.File key={item._id} doraDocItem={item} selectedData={getIndividualTransactionData} seller={seller} getTransactionLaneData={getTransactionLaneData} insideFolder={false} section={section} />;
                              }
                            })
                          : ""}
                      </Tree>
                    </Col>
                  </Row>
                )}
              </Row>
            }
          </div>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}
